module.exports = __webpack_public_path__ + "img/Monte_Kope_63.578e4c81.jpg";